import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const ADJUST_UNREAD_COUNT = 'ADJUST_UNREAD_COUNT';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  unreadCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
  adjustUnreadCount({ commit }, delta) {
    commit(ADJUST_UNREAD_COUNT, delta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      unread_count: unreadCount,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    // O endpoint de filtros avançados não envia unread_count: mantém o último
    $state.unreadCount = unreadCount ?? $state.unreadCount;
    $state.updatedOn = new Date();
  },
  [ADJUST_UNREAD_COUNT]($state, delta) {
    $state.unreadCount = Math.max(0, ($state.unreadCount || 0) + delta);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
